import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
export function formatPlaylistAutoShare(obj) {
  if (obj.teamSharing) {
    var type = obj.teamSharing.find(function (ts) {
      return ts.team_id === '' || ts.team_id === null;
    }) ? 'everyone' : 'teams';
    if (obj.teamSharing.every(function (ts) {
      return +ts.is_deleted;
    })) type = 'null';
    var teams = obj.teamSharing.filter(function (ts) {
      return ts.team_id;
    }).map(function (ts) {
      var _ts$teams;
      return {
        id: +ts.team_id,
        is_deleted: +ts.is_deleted,
        name: ts.teams.name,
        isSmartTeam: Boolean(+ts.teams.isSmartTeam),
        teamType: (_ts$teams = ts.teams) === null || _ts$teams === void 0 ? void 0 : _ts$teams.teamType
      };
    });
    obj.autoShare = {
      type: type,
      teams: teams
    };
    delete obj.teamSharing;
  } else {
    obj.autoShare = {
      teams: [],
      type: 'null'
    };
  }
  return obj;
}